import { Helmet } from "react-helmet-async";

export const SITE_URL = "https://www.mysocietymitra.com";

export function Seo({ title, description, path = "", image, jsonLd }) {
  const url = `${SITE_URL}${path}`;
  const img = image || `${SITE_URL}/mysocietymitra-official-logo.png`;
  return (
    <Helmet prioritizeSeoTags>
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={url} />
      {title && <meta property="og:title" content={title} />}
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      {title && <meta name="twitter:title" content={title} />}
      {description && <meta name="twitter:description" content={description} />}
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
}

export function SiteHead() {
  const gsc = process.env.REACT_APP_GSC_VERIFICATION;
  const ga = process.env.REACT_APP_GA_ID;
  return (
    <Helmet>
      {gsc && <meta name="google-site-verification" content={gsc} />}
      {ga && <script async src={`https://www.googletagmanager.com/gtag/js?id=${ga}`} />}
      {ga && (
        <script>{`window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}gtag('js',new Date());gtag('config','${ga}');`}</script>
      )}
    </Helmet>
  );
}
